import React from 'react';
import './ZoomSlider.css';
import { RESEARCH_CHAT_TEXT_SIZE, readStoredPercent } from '../../utils/textSizeRange';

const ZOOM_MIN = RESEARCH_CHAT_TEXT_SIZE.min;
const ZOOM_MAX = RESEARCH_CHAT_TEXT_SIZE.max;
const ZOOM_DEFAULT = RESEARCH_CHAT_TEXT_SIZE.default;
const ZOOM_STEP = RESEARCH_CHAT_TEXT_SIZE.step;

/**
 * ZoomSlider - Font size zoom control for panels
 *
 * @param {number} value - Current zoom percentage (80-250)
 * @param {function} onChange - Callback when zoom changes
 * @param {string} storageKey - localStorage key for persistence
 */
export function ZoomSlider({ value = ZOOM_DEFAULT, onChange, storageKey }) {
  const handleChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    onChange?.(newValue);
    if (storageKey) {
      localStorage.setItem(storageKey, String(newValue));
    }
  };

  const handleReset = () => {
    onChange?.(ZOOM_DEFAULT);
    if (storageKey) {
      localStorage.setItem(storageKey, String(ZOOM_DEFAULT));
    }
  };

  return (
    <div className="zoom-slider">
      <span className="zoom-slider__icon zoom-slider__icon--small">A</span>
      <input
        type="range"
        min={ZOOM_MIN}
        max={ZOOM_MAX}
        step={ZOOM_STEP}
        value={value}
        onChange={handleChange}
        className="zoom-slider__input"
        title={`Font size: ${value}%`}
      />
      <span className="zoom-slider__icon zoom-slider__icon--large">A</span>
      {value !== ZOOM_DEFAULT && (
        <button
          className="zoom-slider__reset"
          onClick={handleReset}
          title="Reset to 100%"
        >
          {value}%
        </button>
      )}
    </div>
  );
}

// Hook to manage zoom state with localStorage
export function useZoom(storageKey, defaultValue = ZOOM_DEFAULT) {
  const [zoom, setZoom] = React.useState(() => {
    if (storageKey) {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        return readStoredPercent(stored, {
          ...RESEARCH_CHAT_TEXT_SIZE,
          default: defaultValue,
        });
      }
    }
    return defaultValue;
  });

  return [zoom, setZoom];
}

export default ZoomSlider;
